import * as React from "react";
import { FastField } from "formik";
import { FormGroup, Button, RotateLoader, Switch } from "@lib/components";
import { UI } from "../../../../../../../core/ui";
import { MobxComponent } from "../../../../../../../mobx/components";
import { inject, observer } from "mobx-react";
import { RestaurantForm } from "../../../../../../../mobx/components/restaurant-form";

interface Props {
	close?: () => void;
}

type FormValues = { enabled: boolean };

@inject("store") @observer
export class SettingsFormIntegrationKds extends MobxComponent<Props> {
	initialValues: FormValues;

	constructor(props: Props) {
		super(props);
		const r = this.injected.store.restaurant!;
		this.initialValues = {
			enabled: r.kds?.enabled === true,
		};
	}

	render() {
		return (
			<RestaurantForm<FormValues>
				submit={async (r, values) => {
					const stations = r.kds?.stations || [];
					r.kds = { ...(r.kds || {}), enabled: values.enabled, stations };
					const update = { $set: { "kds.enabled": values.enabled === true } };
					return { r, update };
				}}
				initialValues={this.initialValues}
				onSuccess={() => {
					if (this.props.close) this.props.close();
				}}
				onError={() => UI.notification.error("An error occurred")}
				onSuccessMessage="Settings Updated"
			>
				{({ form, error }) => {
					const { isSubmitting, setFieldValue } = form;
					return (
						<div className="p-4">
							<FastField
								name="enabled"
								render={({ field }: any) => (
									<FormGroup
										title="Enabled"
										help="Turning this on shows Kitchen Stations in the left navigation."
									>
										<Switch
											id="kds-enabled-switch"
											checked={field.value === true}
											onChange={(e) => setFieldValue("enabled", e.target.checked)}
										/>
									</FormGroup>
								)}
							/>
							{error && <FormGroup error={error} />}
							<Button full={true} color="primary" type="submit" disabled={isSubmitting}>
								{isSubmitting && <RotateLoader size={2} color="white" />}
								{!isSubmitting && "Save"}
							</Button>
						</div>
					);
				}}
			</RestaurantForm>
		);
	}
}
